import { createSlice } from '@reduxjs/toolkit'
import { clearFilteredData, setEnabledFilter } from '../Search/input'

const emptyFeatureCollection = () => ({
  type: 'FeatureCollection',
  features: [],
})

export const featureCollectionData = createSlice({
  name: 'featureCollection',
  initialState: {
    data: emptyFeatureCollection(),
    reloadVersion: 0,
    temporal: [],
    temporaryOptionsSpecie: null,
    enableSaveButton: {
      specieField: { error: false, selected: null },
      siteField: { error: false, selected: null },
      siteAcronym: { error: false, selected: null },
      sectionField: { error: false, selected: null },
      pseudonymField: { error: false, selected: null },
    },
  },
  reducers: {
    features: (state, action) => {
      state.data = action.payload
    },
    invalidateMapData: state => {
      state.data = emptyFeatureCollection()
      state.reloadVersion += 1
    },
    updateFeatures: (state, action) => {
      const { someId, someValue } = action.payload
      if (someId === null || someId === undefined) return
      if (!state.data.features?.[someId]) return

      const existing = state.data.features[someId].properties || {}
      const next = { ...existing, ...someValue }

      // Preservar identificadores críticos si el backend no los devuelve
      if (existing.id != null && next.id == null) next.id = existing.id
      if (existing.code != null && next.code == null) next.code = existing.code

      state.data.features[someId].properties = next
    },
    updateFeatureGeometry: (state, action) => {
      const { someId, geometry } = action.payload
      // Crear un NUEVO array de features para forzar re-render en Mapbox
      state.data.features = state.data.features.map((feature, index) => {
        if (index === someId) {
          return {
            ...feature,
            geometry: geometry
          }
        }
        return feature
      })
    },
    saveTemporalFeatures: (state, action) => {
      state.temporal = action.payload
    },
    saveTemporaryOptionsSpecie: (state, action) => {
      state.temporaryOptionsSpecie = action.payload
    },
    setEnableSpecieField: (state, action) => {
      state.enableSaveButton.specieField = action.payload
    },
    setEnableSiteField: (state, action) => {
      state.enableSaveButton.siteField = action.payload
    },
    setEnableAcronymField: (state, action) => {
      state.enableSaveButton.siteAcronym = action.payload
    },
    setEnableSectionField: (state, action) => {
      state.enableSaveButton.sectionField = action.payload
    },
    setEnablePseudonymField: (state, action) => {
      state.enableSaveButton.pseudonymField = action.payload
    },
  },
})

export const {
  features,
  invalidateMapData,
  updateFeatures,
  updateFeatureGeometry,
  saveTemporalFeatures,
  saveTemporaryOptionsSpecie,
  setEnableSpecieField,
  setEnableSiteField,
  setEnableAcronymField,
  setEnableSectionField,
  saveTemporalInputPseudonym,
  setEnablePseudonymField,
} = featureCollectionData.actions

/**
 * Recarga los árboles del mapa sin búsqueda activa. El popup y la ficha dependen de la sesión: al entrar o al
 * perderla no deben quedar en memoria los datos cargados con la anterior. Con una búsqueda activa
 * useLoadMapData no recarga y los popups se quedarían sin datos, por eso se desactiva primero.
 */
export const reloadMapDataForSession = () => dispatch => {
  dispatch(setEnabledFilter(false))
  dispatch(clearFilteredData())
  dispatch(featureCollectionData.actions.invalidateMapData())
}

export default featureCollectionData.reducer
